import {useDispatch, useSelector} from 'react-redux';
import { Navigate } from 'react-router-dom';
import SessionTimer from "./sessionTimer";
import {logoutUser} from "../../actions/session";
import {SESSION_LOGOUT_SECONDS, SESSION_POLL_SECONDS, SESSION_WARN_SECONDS} from "../../constants";
import {userCanAccess} from "../../utils/users";

const AuthenticatedRoute = (props) => {
  const loggedIn = useSelector((state) => state.session.loggedIn);
  const userComposite = useSelector((state) => state.session.currentUserComposite);
  const mustAcceptTermsUser = useSelector((state) => state.session.mustAcceptTermsUser);
  let targetRoute = props.to || '/';
  const dispatch = useDispatch();

  const exitAction = () => {
    dispatch(logoutUser());
  }

  function isAuthorized ()  {
    return mustAcceptTermsUser || ((loggedIn) && (userComposite && userCanAccess(userComposite, props.permission)));
  }

  return (isAuthorized()) ? (
    <>
      <SessionTimer logoutSeconds={SESSION_LOGOUT_SECONDS} warnSeconds={SESSION_WARN_SECONDS} pollSeconds={SESSION_POLL_SECONDS} modalDiv={"session-timeout"} exitAction={exitAction} disabled={mustAcceptTermsUser}/>
      {props.children}
    </>
  ) : (<Navigate to={targetRoute} />);
}

export default AuthenticatedRoute;
